import { TranslateKey, TranslateOptions } from './i18n.types';
import { useTranslation } from 'react-i18next';
import { initialiseTranslations } from './initialiseTranslations';

const i18n = initialiseTranslations();
// If you need to access the t function or
// the i18next instance from outside of a React
export function translate(key: TranslateKey, options?: TranslateOptions) {
    return i18n.t(key, options);
}

export const useAppTranslate = () => {
    const { t, ...rest } = useTranslation();

    function translate(key: string, options?: TranslateOptions) {
        return t(key, options);
    }

    return {
        t: translate,
        ...rest,
    };
};
